/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';
import { ReleaseTypeEnum } from './releaseTypeEnum';


export interface UpgradeDeploymentSpec { 
    /**
     * List of Deployment Ids to work on in a Service
     */
    deployment_ids?: Array<string>;
    /**
     * Set it to True if operator wants to upgrade to a specific to_version, from a list of possibe upgrade options for a deployment. Auto upgrade is only possible if only one default option.
     */
    force: boolean;
    /**
     * Ord ID
     */
    org_id?: string;
    release_type?: ReleaseTypeEnum;
    service_type: ServiceTypeEnum;
    /**
     * Target release to be upgraded to in a Service
     */
    target_release?: string;
}
export namespace UpgradeDeploymentSpec {
}


